import {
  IFileGateway,
  IJobGateway,
  IProjectGateway,
  PresenterFunc,
  UpdaterFunc,
  ProjectInput,
} from '@/core/interface';
import { ProjectService } from '@/core/usecase';
import { Project } from '@/core/entity';
import { Fragment } from '@/core/interface/common';

export class ProjectControler {
  private readonly service: ProjectService;

  constructor(
    fileGw: IFileGateway,
    jobGw: IJobGateway,
    projectGw: IProjectGateway,
  ) {
    this.service = new ProjectService(fileGw, jobGw, projectGw);
  }

  public create(
    input: ProjectInput,
    file: File,
    presenter: PresenterFunc<Project | null>,
    fragment?: Fragment,
    updater?: UpdaterFunc,
  ) {
    this.service.createProject(input, file, presenter, fragment, updater);
  }

  public remove(
    id: string,
    presenter: PresenterFunc<Project | null>,
    fragment?: Fragment,
    updater?: UpdaterFunc,
    refetchQueries?: string[],
  ) {
    this.service.removeProject(id, presenter, fragment, updater, refetchQueries);
  }

  public update(
    id: string,
    input: ProjectInput,
    presenter: PresenterFunc<Project | null>,
    fragment?: Fragment,
    updater?: UpdaterFunc,
  ) {
    this.service.updateProject(id, input, presenter, fragment, updater);
  }
}
